import type { PageUpdate } from "../../../shared/src/page-updates";
import { examplePostComments } from "../../../shared/src/example-post-comments";
import { creatorInitials } from "../../../shared/src/creator-initials";
import { AccordionItem } from "./ui-kit/accordion";

/** Example-only threads never submit comments or stand in for real member conversation. */
export function PostExampleComments({
  item,
  creatorName,
  linkTo,
  defaultOpen,
}: {
  item: Pick<PageUpdate, "example" | "locked">;
  creatorName: string;
  linkTo: (href: string) => string;
  defaultOpen?: boolean;
}) {
  const thread = examplePostComments(item);
  if (!thread) return null;
  return (
    <section className="drate-post-comments" aria-label="Example comments" data-example-comments="">
      <AccordionItem
        title={
          thread.count === null
            ? "Members-only comments · Example"
            : `${thread.count} comments · Example`
        }
        open={!item.locked && (defaultOpen ?? true)}
      >
        {item.locked ? (
          <p className="drate-post-comment-gate">
            <a href={linkTo("/join")}>Join to read the conversation</a>
          </p>
        ) : (
          <>
            <p className="drate-post-comments-note">An example conversation with your community.</p>
            <ol className="drate-post-comment-list">
              {thread.items.map((comment) => {
                const name = comment.author ?? creatorName;
                return (
                  <li
                    key={comment.id}
                    className="drate-post-comment"
                    data-reply={comment.reply ? "" : undefined}
                  >
                    <span className="drate-post-avatar" aria-hidden="true">
                      {creatorInitials(name)}
                    </span>
                    <div className="drate-post-comment-copy">
                      <div className="drate-post-comment-meta">
                        <strong>{name}</strong>
                        {!comment.author && <span>Creator</span>}
                        <span>{comment.when}</span>
                      </div>
                      <p>{comment.body}</p>
                      <a className="drate-post-comment-reply" href={linkTo("/sign-in")}>
                        Reply
                      </a>
                    </div>
                  </li>
                );
              })}
            </ol>
            <a className="button button-outline drate-post-comment-join" href={linkTo("/sign-in")}>
              Sign in to join the conversation
            </a>
          </>
        )}
      </AccordionItem>
    </section>
  );
}
